import heroLogo from "@/assets/services/hero.svg";
import studyhubLogo from "@/assets/services/studyhub.svg";

/**
 * Знак сервиса для кнопки «Перейти в …» на финале мастера.
 *
 * ПОЧЕМУ ФАЙЛ ИЗ РЕПОЗИТОРИЯ, А НЕ ПАРАМЕТР ЗАПРОСА — разбор в шапке
 * `components/signin/service-badge.tsx`: логотип, принятый снаружи, ставит
 * чужой бренд на наш домен (фишинг) и приносит исполняемый SVG на страницу,
 * где человек вводит код из письма (XSS). Здесь тот же реестр и та же причина.
 *
 * Отличие от знака на экране входа одно: фолбэка-глифа нет. На входе знак
 * подписывает, КУДА человек входит, и глиф там лучше пустоты; в кнопке он
 * украшение рядом с уже написанным именем сервиса, и лишняя иконка внутри
 * кнопки только шумит.
 */
const LOGOS: Readonly<Record<string, string>> = {
	hero: heroLogo,
	studyhub: studyhubLogo,
};

/**
 * Два сервиса знака НЕ получают (решение владельца 23.08.2026): `iec-id` —
 * человек идёт к нам же, и `exchange` — Портал неразрывно связан с единым
 * профилем. Список нужен и на будущее: появится файл знака — исключение
 * останется решением, а не забытым пробелом.
 */
const WITHOUT_MARK: readonly string[] = ["iec-id", "exchange"];

export function serviceMarkSrc(serviceId: string): string | undefined {
	if (WITHOUT_MARK.includes(serviceId)) return undefined;
	return LOGOS[serviceId];
}

/** Знак 20px внутри кнопки. `null`, когда знака нет, — кнопка остаётся подписью. */
export function ServiceMark({ serviceId }: { serviceId: string }) {
	const logo = serviceMarkSrc(serviceId);
	if (!logo) return null;
	// Имя сервиса стоит в подписи кнопки рядом, поэтому знак для скринридера —
	// украшение, а не вторая копия того же слова.
	return <img src={logo} alt="" aria-hidden="true" className="size-5 rounded-chip" />;
}
